import type { ComputedRef } from 'vue'
import { computed } from 'vue'

import { RoleEnumTypeV2 } from '@/features/auth/types'
import type { V2ProgramType } from '@/features/programs/types'

/**
 * Hook pour déterminer les permissions dashboard selon rôle et paramètres programme
 */
function useDashboardPermissions({
  programRolesRef,
  programRef,
}: {
  programRolesRef: ComputedRef<RoleEnumTypeV2[] | undefined>
  programRef: ComputedRef<V2ProgramType | undefined>
}) {
  /**
   * Détermine si l'utilisateur peut planifier des sessions
   * - Mentors : toujours autorisés
   * - Mentees : uniquement si menteeCanBookSession activé
   */
  const canPlanSessionRef = computed(() => {
    // Mentors can always plan sessions
    if (programRolesRef.value?.includes(RoleEnumTypeV2.MENTOR)) {
      return true
    }
    // Mentees can only plan if the setting allows it
    if (
      programRolesRef.value?.includes(RoleEnumTypeV2.MENTEE) &&
      programRef.value?.settings.menteeCanBookSession
    ) {
      return true
    }
    return false
  })

  /**
   * Détermine si l'utilisateur est un mentor dans ce programme
   */
  const isMentorRef = computed(() => programRolesRef.value?.includes(RoleEnumTypeV2.MENTOR))

  /**
   * Détermine si l'utilisateur est un mentee dans ce programme
   */
  const isMenteeRef = computed(() => programRolesRef.value?.includes(RoleEnumTypeV2.MENTEE))

  return {
    canPlanSessionRef,
    isMentorRef,
    isMenteeRef,
  }
}

export default useDashboardPermissions
